"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
function executeScripts(element) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var loadScript, scripts, _i, scripts_1, script;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    loadScript = function (el) {
                        var parent = el.parentElement;
                        if (!parent) {
                            return;
                        }
                        var next = el.nextSibling;
                        parent.removeChild(el);
                        return new Promise(function (resolve) {
                            var newEl = document.createElement('script');
                            for (var i = 0; i < el.attributes.length; i++) {
                                var a = el.attributes[i];
                                newEl.setAttribute(a.name, a.value);
                            }
                            var onLoad = function () {
                                newEl.removeEventListener('load', onLoad);
                                resolve();
                            };
                            newEl.addEventListener('load', onLoad);
                            next ? parent.insertBefore(newEl, next) : parent.appendChild(newEl);
                        });
                    };
                    scripts = Array.prototype.slice.call(element.querySelectorAll('script'));
                    _i = 0, scripts_1 = scripts;
                    _a.label = 1;
                case 1:
                    if (!(_i < scripts_1.length)) return [3 /*break*/, 7];
                    script = scripts_1[_i];
                    if (!script.src) return [3 /*break*/, 5];
                    if (!(script.async || script.defer)) return [3 /*break*/, 2];
                    loadScript(script); // async/deferred so we can safely execute the next scripts
                    return [3 /*break*/, 4];
                case 2: return [4 /*yield*/, loadScript(script)];
                case 3:
                    _a.sent();
                    _a.label = 4;
                case 4: return [3 /*break*/, 6];
                case 5:
                    new Function(script.text)();
                    _a.label = 6;
                case 6:
                    _i++;
                    return [3 /*break*/, 1];
                case 7: return [2 /*return*/];
            }
        });
    });
}
exports.default = executeScripts;
